import { Link } from "react-router-dom";
import { ExternalLink, Mail } from "lucide-react";
import { navItems, site } from "../data/site";
import { featuredProjects } from "../data/projects";
import { socials } from "../data/social";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        <div>
          <Link to="/" className="brand footer-brand">
            <span className="brand-mark logo-mark"><img src="/assets/brand/logo.png" alt="" /></span>
            <span>
              <strong>{site.shortName}</strong>
              <small>Independent game studio · {site.location}</small>
            </span>
          </Link>
          <p>{site.tagline}</p>
          <p className="muted">© {new Date().getFullYear()} SZ Interactive Ltd. All rights reserved.</p>
        </div>
        <FooterColumn title="Navigate" links={navItems} />
        <div>
          <h2>Steam</h2>
          {featuredProjects.map((project) => (
            <a key={project.slug} className="footer-link" href={project.storeUrl} target="_blank" rel="noreferrer">
              {project.title} <ExternalLink size={14} aria-hidden="true" />
            </a>
          ))}
        </div>
        <div>
          <h2>Contact</h2>
          <a className="footer-link" href={`mailto:${site.email}`}>
            <Mail size={14} aria-hidden="true" /> {site.email}
          </a>
          {socials.map((social) => (
            <a key={social.href} className="footer-link" href={social.href} target="_blank" rel="noreferrer">
              {social.label} <ExternalLink size={14} aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, links }: { title: string; links: { label: string; href: string }[] }) {
  return (
    <div>
      <h2>{title}</h2>
      {links.map((link) => (
        <Link key={link.href} className="footer-link" to={link.href}>
          {link.label}
        </Link>
      ))}
    </div>
  );
}
